// components/sections/MotherInfoSection.tsx
import React from "react";
import { Heart, User, Clock, Phone, MapPin, Users } from "lucide-react";
import { InputField } from "../form/FormComponents_PediatricsRegistration";
import type { FormData } from "../../types/consultation";

interface MotherInfoSectionProps {
  formData: FormData;
  updatePediatricsInfo: (field: string, value: string | boolean) => void;
}

export const MotherInfoSection: React.FC<MotherInfoSectionProps> = ({
  formData,
  updatePediatricsInfo,
}) => {
  return (
    <div className="bg-gradient-to-br from-pink-50 to-rose-50 p-6 rounded-2xl shadow-lg border border-pink-100 mb-8">
      <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
        <Heart className="mr-2 text-pink-600" size={24} />
        Informations de la Mère
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <InputField
          label="Nom de la mère"
          value={formData.pediatrieInfo?.nomMere || ""}
          onChange={(value) => updatePediatricsInfo("nomMere", value)}
          icon={User}
          required
        />

        <InputField
          label="Âge"
          value={formData.pediatrieInfo?.ageMere || ""}
          onChange={(value) => updatePediatricsInfo("ageMere", value)}
          type="number"
          icon={Clock}
        />

        <InputField
          label="Téléphone"
          value={formData.pediatrieInfo?.telephoneMere || ""}
          onChange={(value) => updatePediatricsInfo("telephoneMere", value)}
          type="tel"
          icon={Phone}
        />

        <div className="lg:col-span-2">
          <InputField
            label="Adresse"
            value={formData.pediatrieInfo?.adresseMere || ""}
            onChange={(value) => updatePediatricsInfo("adresseMere", value)}
            icon={MapPin}
          />
        </div>

        <InputField
          label="Fonction"
          value={formData.pediatrieInfo?.fonctionMere || ""}
          onChange={(value) => updatePediatricsInfo("fonctionMere", value)}
          icon={Users}
        />
      </div>
    </div>
  );
};